var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKron = function SvgKron(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.1 323.402C372.7 265.302 429.5 223.102 496.7 223.102C564.5 223.102 621.7 266.002 639.8 324.902",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M669 533.902C666.2 528.802 663.1 523.802 659.7 519.002C624.9 468.502 564.9 435.102 496.7 435.102C427.4 435.102 366.6 469.502 332.1 521.302C329.4 525.402 326.8 529.602 324.4 533.902",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M627.5 646.902C627.5 645.002 627.5 643.002 627.3 641.102C625 593.902 595.1 553.602 552.6 534.502C552.1 534.302 551.6 534.002 551.1 533.802C551.1 533.802 551.1 533.802 551 533.802C550.5 533.602 550.1 533.402 549.6 533.202C533.5 526.402 515.6 522.602 496.8 522.602C477.4 522.602 459.1 526.602 442.6 533.802H442.5H442.4C441.9 534.002 441.4 534.202 441 534.402C398.5 553.502 368.5 593.802 366.3 641.002C366.2 642.902 366.1 644.802 366.1 646.802",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M442.4 364.803C442.4 336.303 466.7 313.203 496.7 313.203C526.7 313.203 551 336.303 551 364.803C551 365.003 551 365.303 551 365.503C551 369.503 550.4 373.303 549.5 377.003",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M551.1 365.503C551.1 365.303 551.1 365.003 551.1 364.803C551.1 336.303 575.4 313.203 605.4 313.203C618.5 313.203 630.5 317.603 639.8 324.903C651.9 334.403 659.7 348.803 659.7 364.903C659.7 365.103 659.7 365.403 659.7 365.603",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.9 365.503C440.9 365.303 440.9 365.003 440.9 364.803C440.9 336.303 416.6 313.203 386.6 313.203C374.4 313.203 363.2 317.003 354.2 323.403C340.9 332.803 332.3 347.903 332.3 364.803C332.3 365.003 332.3 365.303 332.3 365.503",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M549.6 533.898H551H551.1",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M442.5 533.898H442.3H440.9",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M442.5 533.898H442.3H440.9",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 533.898H267.3C249.7 533.898 235.5 548.098 235.5 565.698V875.698C235.5 893.298 249.7 907.498 267.3 907.498H366H627.4H726.2C743.8 907.498 758 893.298 758 875.698V565.698C758 548.098 743.8 533.898 726.2 533.898H669",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M549.6 533.898H551H551.1",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M551.1 364.797V365.497V442.397",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440.9 533.898H442.3H442.4",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M440.9 442.797V365.497V364.797H442.4",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M551.1 533.898H549.6",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M442.3 533.898V534.598H440.9",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.2 521.3V365.5H332.3",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M440.9 365.5H442.3V442.4",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M549.6 442V377V365.5H551.1",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M659.8 365.5V518.9",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M552.6 534.597H549.6V533.897V533.297",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M497 598.797V683.297",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M366.2 641.203H366V646.903V907.403H627.5V757.203V646.903V641.203H627.3",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M496.8 199.803C501.936 199.803 506.1 195.639 506.1 190.503C506.1 185.367 501.936 181.203 496.8 181.203C491.664 181.203 487.5 185.367 487.5 190.503C487.5 195.639 491.664 199.803 496.8 199.803Z",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M496.8 215.497V94.7969",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241 365.002V233.602",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M757.2 365.002V233.602",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 789.997C427.1 788.997 427.1 787.897 427.2 786.897C428.4 761.797 444.3 740.297 467 730.097C467.2 729.997 467.4 729.897 467.6 729.797",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M525.9 729.797C526.1 729.897 526.3 729.997 526.5 730.097C549.2 740.297 565.1 761.797 566.3 786.897C566.4 787.897 566.4 788.897 566.4 789.997",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M427.2 786.898H427.1V789.998V798.698",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M566.4 798.698V789.998V786.898H566.3",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M525.9 729.798C526.3 727.798 526.5 725.798 526.5 723.698C526.5 707.298 513.2 693.898 496.7 693.898C480.3 693.898 467 707.198 467 723.698C467 725.798 467.2 727.798 467.6 729.698",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 798.703H366",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M627.5 798.703H566.4",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M526.6 815.102H467.9V907.502H526.6V815.102Z",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M666.7 443.398H821.3V887.098C821.3 898.298 812.2 907.398 801 907.398H736.3",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M331.9 443.398H177.3V887.098C177.3 898.298 186.4 907.398 197.6 907.398H262.3",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M304.9 443.403C305.3 440.703 305.4 438.003 305.4 435.203C305.4 400.103 277 371.703 241.9 371.703C206.8 371.703 178.4 400.103 178.4 435.203C178.4 438.003 178.6 440.703 178.9 443.403",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M820.8 443.4C821.2 440.7 821.3 437.9 821.3 435.1C821.3 399.1 792.1 370 756.2 370C720.3 370 691 399.1 691 435.1C691 437.9 691.2 440.7 691.5 443.4",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/kron.svg";